module.exports = __webpack_public_path__ + "static/media/arab22.9644adbd.wav";